import React from 'react';
import { FormControl, OutlinedInput, Select as MuiSelect, MenuList, Box } from '@mui/material';
import { SearchField } from './components/SearchField';
import { OptionsList } from './components/OptionsList';
import { MULTI_SELECT_CONSTANTS } from './constants';
import { useMultiSelect } from '../../hooks/useMultiSelect';
import { filterOptions, formatSelectedValues } from './utils/MultiSelectUtils';
import { MultiSelectProps } from './types';
import './MultiSelect.scss';

export const MultiSelect: React.FC<MultiSelectProps> = ({
  id = 'multiselect',
  name = 'multiselect',
  options,
  value,
  onChange,
  placeholder,
  className = '',
  label,
  error,
  onBlur,
}) => {
  const {
    searchText,
    searchInputRef,
    handleSearchChange,
    handleMenuItemClick,
    handleClose,
    setMenuOpen,
  } = useMultiSelect(value, onChange);

  const filteredOptions = filterOptions(options, searchText);

  const menuContent = (
    <MenuList>
      <Box p={1} onKeyDown={(e) => e.stopPropagation()}>
        <SearchField
          searchText={searchText}
          onChange={handleSearchChange}
          inputRef={searchInputRef}
        />
      </Box>
      <OptionsList
        options={filteredOptions}
        selectedValues={value}
        searchText={searchText}
        onOptionClick={handleMenuItemClick}
      />
    </MenuList>
  );

  return (
    <div className="select-wrapper">
      {label && <label className="select-label">{label}</label>}
      <FormControl className={`select ${className} ${error ? 'error' : ''}`}>
        <MuiSelect
          id={id}
          name={name}
          multiple
          value={value}
          onBlur={onBlur}
          onOpen={() => setMenuOpen(true)}
          onClose={handleClose}
          input={<OutlinedInput />}
          renderValue={(selected) => formatSelectedValues(selected, options, placeholder)}
          MenuProps={{
            ...MULTI_SELECT_CONSTANTS.MENU_PROPS,
          }}
          displayEmpty
          size="small"
        >
          {menuContent}
        </MuiSelect>
      </FormControl>
      {error && <div className="select-error">{error}</div>}
    </div>
  );
};
